import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useClientTypes from "@/features/clientType/hooks/useClientTypes";
const ClientTypeRadioGroup = ({ value, onChange }) => {
    const { clientTypes, loading, error } = useClientTypes();
    if (loading) {
        return _jsx("div", { children: "Chargement des types de client..." });
    }
    if (error) {
        return _jsxs("div", { children: ["Erreur: ", error] });
    }
    return (_jsxs("div", { className: "flex flex-col sm:flex-row items-start sm:items-center gap-4", children: [_jsx("span", { className: "font-medium", children: "Type de client :" }), clientTypes.map((type) => (_jsxs("label", { className: "flex items-center gap-2", children: [_jsx("input", { type: "radio", name: "client_type", value: type.code, checked: value === type.code, onChange: onChange, className: "w-4 h-4" }), type.label] }, type.code)))] }));
};
export default ClientTypeRadioGroup;
